import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { usePermissions, useTranslate } from 'react-admin';
import ShowIcon from '@/assets/icons/show-icon.svg?react';
import { useDrawer } from '@/composables/useDrawer';
import { canViewDeviceConfig, DEVICE_CONFIG_DRAWER_ID } from '@/helpers/device/deviceConfig.js';

export const ShowDeviceConfigListButton = ({ onClose }) => {
    const { permissions } = usePermissions();
    const { openDrawer } = useDrawer();
    const translate = useTranslate();

    if (!canViewDeviceConfig(permissions)) {
        return null;
    }

    const label = translate('resources.device.labels.showDeviceConfiguration');

    return (
        <Button
            onClick={() => {
                onClose?.();
                openDrawer(DEVICE_CONFIG_DRAWER_ID, 'device-config');
            }}
            aria-label={label}
        >
            <ShowIcon /> {label}
        </Button>
    );
};

ShowDeviceConfigListButton.propTypes = {
    onClose: PropTypes.func,
};
